import { LEVELS } from "@package/map";

import { Card, Stack, Typography, Switch, Grid } from "@mui/material";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { toggleVisibility } from "Redux/inventorySlice";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import DatePicker from "Components/DatePicker";
import TimePicker from "Components/TimePicker";
import LoadingButton from "@mui/lab/LoadingButton";
import { changeDate, changeSurveysFilter } from "Redux/filtersSlice";

export default function Time() {
  const dispatch = useAppDispatch();
  const { surveys, date } = useAppSelector((state) => state.filters);
  const { visible } = useAppSelector((state) => state.inventory);
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const handleVisible = () => {
    dispatch(toggleVisibility());
  };

  const handleSetDateRange = (obj: any) => {
    dispatch(changeDate(obj));
    // dispatch(changeSurveysFilter(obj));
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack spacing={2} direction="row" style={{ alignItems: "center" }}>
        <Grid container spacing={1} mb={2}>
          <Grid item xs={12} md={12}>
            <DatePicker
              label="تاریخ ثبت"
              name="date"
              // data={surveys}
              data={date}
              isRange={true}
              setData={(value) => handleSetDateRange(value)}
            />
          </Grid>
          {/*          
          <Grid item xs={12} md={0.8}>
            <TimePicker
              label=" رسیدن از"
              name="go_after"
              data={surveys}
              setData={(value) => handleSetFilter("go_after", value)}
            />
          </Grid>
          <Grid item xs={12} md={0.8}>
            <TimePicker
              label=" رسیدن تا"
              name="go_before"
              data={surveys}
              setData={(value) => handleSetFilter("go_before", value)}
            />
          </Grid>
          <Grid item xs={12} md={0.9}>
            <TimePicker
              label=" برگشت از"
              name="return_after"
              data={surveys}
              setData={(value) => handleSetFilter("return_after", value)}
            />
          </Grid>
          <Grid item xs={12} md={0.9}>
            <TimePicker
              label=" برگشت تا"
              name="return_before"
              data={surveys}
              setData={(value) => handleSetFilter("return_before", value)}
            />
          </Grid> */}
          {/* <Grid item xs={12} md={0.9}>
            <LoadingButton loading={isFetching} fullWidth variant="contained" size="large" onClick={filterList}>
              فیلتر
            </LoadingButton>
          </Grid> */}
        </Grid>
        <Stack direction="row" style={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px !important", mb: "0 !important" }}>نمایش</Typography>
          <Switch {...label} onChange={handleVisible} checked={visible} />
        </Stack>
      </Stack>
    </Card>
  );
}
